import { motion } from "framer-motion";
import { socials } from "./socials";
import { SVGProps, useEffect, useState } from "react";
import styled from "styled-components";

export const SocialFeed = () => {
  const [service, setService] = useState("facebook");
  const feedMap = {
    facebook: "5328a85c210e92e6cb994412cf384801f6fd220f",
    twitter: "27dea6c1c34402ced1f2faa18d06c27b841f18e0",
    instagram: "9f7748e2f882161560c5333e9b23fedab74d9267",
    tiktok: "eb33979eeeb83ecf5ea25571a52d0136fb1a73f4",
  };
  //@ts-ignore
  let feed = feedMap[service];

  useEffect(() => {
    if (feed) {
      (function (d, s, id) {
        var js;
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        //@ts-ignore
        js.src = "https://embedsocial.com/cdn/ht.js";
        d.getElementsByTagName("head")[0].appendChild(js);
      })(window.document, "script", "EmbedSocialHashtagScript");
      return () => {
        window.document.getElementById("EmbedSocialHashtagScript")?.remove();
      };
    }
  }, [feed]);

  return (
    <Container>
      <Options>
        {socials.map(
          ({
            key,
            Image,
          }: {
            key: string;
            Image: (props: SVGProps<SVGSVGElement>) => JSX.Element;
          }) => (
            <Social
              as={motion.div}
              whileTap={{ scale: 0.9 }}
              whileHover={{ scale: 1.2 }}
              key={key}
              style={{ borderColor: key === service ? "#1700F4" : "#fff" }}
              onClick={() => setService(key)}
            >
              <Image
                style={{ color: key === service ? "#1700F4" : "#020C29" }}
              />
            </Social>
          )
        )}
      </Options>
      <div className="embedsocial-hashtag" data-ref={feed}></div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 0 auto;
  max-width: 1200px;
`;

const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 30px;
  width: 40%;
  margin: 30px auto;
  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 100%;
  }
`;

const Social = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  background: #fff;
  margin: 5px;
  color: #020c29;
  border-bottom: 3px;
  border-style: solid;
  &:hover {
  }
`;
